import axios from 'axios';
import { config } from '../../config/client.js';

// Utility function to get token without importing AuthService
async function getAuthToken() {
  try {
    const storedData = localStorage.getItem('user');
    if (storedData) {
      const data = JSON.parse(storedData);
      // Check all possible token locations
      const token = data.accessToken || data.token || data.idToken;
      return token;
    }
  } catch (error) {
    console.error('Error getting token:', error);
  }
  return null;
}

const api = axios.create({
  baseURL: config.serverUrl,
});

api.interceptors.request.use(async (config) => {
  try {
    // In development mode, use a mock token
    if (process.env.NODE_ENV === 'development') {
      config.headers['Authorization'] = `Bearer dev-mock-token`;
    } else {
      const token = await getAuthToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
  } catch (error) {
    console.error('Error getting token for API request:', error);
  }
  return config;
});

export { api };

export async function getUserHistory(userId) {
  const response = await api.get(`/api/history/${userId}`);
  return response.data;
}

export async function saveUserHistory(userId, history) {
  const response = await api.post(`/api/history/${userId}`, history);
  return response.data;
}